import { combineValidateRules } from 'legacy/lut/helpers/combineValidateRules'
import React from 'react'

import { Roles } from 'clickNgo/configs/roles'
import { IInputProps } from 'core-components/library/inputs'
import { isEmpty, isValidEmail } from 'core-components/library/validation'
import { IValidatorProps } from 'core-components/library/validation'
import { Controller } from 'core-components/library/validation'
import { ILocationTree, LocationTree } from 'core/components/shared/ui/LocationTree'
import { VisualAudience } from 'core/components/shared/ui/VisualAudience'
import { OnboardingValidateInput } from 'onboarding/components/ui/theme'

import styles from './EndUser.module.scss'

export interface IEndUser {
  EntryId?: number
  EndUserAddress: string
  EndUserContactPhone: string
  EndUserDesignation: string
  EndUserEmail: string
  EndUserName: string
  TerritoryOfSale: string
  RequestId: number
}

interface IProps {
  endUser: IEndUser
  onChange: (value: string, field: string) => void
  disabled?: boolean
}

const responsibleRoles = [Roles.CONTRACT_OPERATIONS]

export const EndUser = ({ endUser, onChange, disabled }: IProps) => {
  return (
    <Controller>
      <p className={styles.title}>
        <span className={styles.title__bold}>End User Details</span> (This section will be filled in
        ONLY if this is a <span className={styles.title__underline}>ONCE Off-Deal</span> request)
      </p>
      <div className={styles.row}>
        <div className={styles.col}>
          <VisualAudience<IInputProps & IValidatorProps>
            component={OnboardingValidateInput}
            write={responsibleRoles}
            checkFn={isEmpty}
            label={'End-User Name'}
            value={endUser.EndUserName}
            onChange={(value) => onChange(value, 'EndUserName')}
            margin={'sm'}
            disabled={disabled}
          />
          <VisualAudience<IInputProps & IValidatorProps>
            component={OnboardingValidateInput}
            write={responsibleRoles}
            checkFn={isEmpty}
            label={'End-User Contact Person/Designation'}
            value={endUser.EndUserDesignation}
            onChange={(value) => onChange(value, 'EndUserDesignation')}
            margin={'sm'}
            disabled={disabled}
          />
          <VisualAudience<IInputProps & IValidatorProps>
            component={OnboardingValidateInput}
            write={responsibleRoles}
            checkFn={isEmpty}
            label={'End-User Address'}
            value={endUser.EndUserAddress}
            onChange={(value) => onChange(value, 'EndUserAddress')}
            margin={'sm'}
            disabled={disabled}
          />
        </div>
        <div className={styles.col}>
          <VisualAudience<IInputProps & IValidatorProps>
            component={OnboardingValidateInput}
            write={responsibleRoles}
            checkFn={isEmpty}
            label={'End-User Contact Phone'}
            value={endUser.EndUserContactPhone}
            onChange={(value) => onChange(value, 'EndUserContactPhone')}
            margin={'sm'}
            disabled={disabled}
          />
          <VisualAudience<IInputProps & IValidatorProps>
            component={OnboardingValidateInput}
            write={responsibleRoles}
            checkFn={combineValidateRules([isEmpty, isValidEmail])}
            label={'End-User Contact Email Address'}
            value={endUser.EndUserEmail}
            onChange={(value) => onChange(value, 'EndUserEmail')}
            margin={'sm'}
            disabled={disabled}
          />
          <VisualAudience<ILocationTree>
            write={responsibleRoles}
            component={LocationTree}
            label="Territory of Sale"
            value={(endUser.TerritoryOfSale || '').split(',')}
            onChange={(value) => onChange(value.join(','), 'TerritoryOfSale')}
            root={`Region-APJ`}
            margin={'sm'}
            checkFn={isEmpty}
            hideHpOrg
            disabled={disabled}
          />
        </div>
      </div>
    </Controller>
  )
}
